/* global angular, jQuery, _ */

var ngModule = angular.module('trends');
var $ = jQuery;

// TODO: refactor to use the query serializer.
ngModule.directive('location', ['$location', '$history', '$q', 'Monitor', '$timeout', '$window', 'BrowserDetector',
    function ($location, $history, $q, Monitor, $timeout, $window, BrowserDetector) {
        return {
            require: 'location',
            controllerAs: '$location',
            controller: ['$element', function ($element) {
                this.jumpToElement = function (el, duration, callback) {
                    // Note: undefined > 0 === false
                    if (duration > 0) {
                        var browser = BrowserDetector.getBrowserInfo();
                        if (browser.name === 'IE' || browser.name === 'MSIE'){
                            $('html').animate({
                                scrollTop: el.offset().top
                            }, {duration:duration, complete:callback});
                        }
                        else {
                            $('body').animate({
                                scrollTop: el.offset().top
                            }, {duration:duration, complete:callback});
                        }
                    } else {
                        $window.scrollTo($window.pageXOffset,el.offset().top);
                    }
                };

                this.isInfinite = function () {
                    return $element.find('*[data-infinite-scroll]').length > 0;
                };

                this.changing = new Monitor();
                this.stateCount = 0;
            }],
            link: function (scope, element, attrs, ctrl) {
                var deferred = null;

                var resolve = function () {
                    if (deferred) {
                        deferred.resolve();
                    }
                };

                scope.$on('$stateChangeStart', function () {
                    ctrl.stateCount++;

                    deferred = $q.defer();
                    ctrl.changing.watch(deferred.promise);
                });

                scope.$on('$stateChangeSuccess', function () {
                    // initially jump to the top of the page
                    ctrl.jumpToElement(element, 0);

                    var target = $location.search().to;
                    if (target) {
                        var last_scroll = 0;
                        var animating = 0;
                        var watch = scope.$watch(
                            function(){
                                var el = $('#' + target);
                                return el.length ? el.offset().top : 0;
                            },
                            _.debounce(
                                function(offset){
                                    if (last_scroll !== $window.pageYOffset && !animating){
                                        watch();
                                    }
                                    else if (offset !== $window.pageYOffset && offset > 0){
                                        var el = $('#' + target);
                                        if (el.length > 0 && offset > 0) {
                                            last_scroll = offset;
                                            animating += 1;
                                            ctrl.jumpToElement(el, 1000, function(){animating-=1;});
                                            $location.search('to', null);
                                        }
                                    }
                                },
                            300)
                        );
                    }

                    resolve();
                });

                scope.$on('$stateChangeError', function () {
                    resolve();
                });
            }
        };
    }]);
